import {createAction} from 'redux-actions';
import {PATH_CHANGE} from '../action-types';

export const pathChange = createAction(PATH_CHANGE);
